module.exports = __webpack_public_path__ + "fonts/7f562c00d80cb9d59bed376763039487.woff2";